<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("logs") }}
        </h1>
      </div>
    </div>
    <LogsTable />
  </div>
</template>

<script>
import LogsTable from './components/LogsTable.vue';

export default {
  components: { LogsTable },
};
</script>
